export const PublicScoresheetType = '/scoresheet';
export const PublicLeaderBoardType = '/leaderboard/:eventId/:leaderboardId'